import { render, staticRenderFns } from "./branded-fare-upsell.vue?vue&type=template&id=6af09529"
import script from "./branded-fare-upsell.vue?vue&type=script&lang=js"
export * from "./branded-fare-upsell.vue?vue&type=script&lang=js"
import style0 from "./branded-fare-upsell.vue?vue&type=style&index=0&id=6af09529&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports